<template>
  <div class="solution-security">
    <div class="banner">
      <solution-banner :bannerInfo="bannerConstant.SolutionInsurance"></solution-banner>
    </div>
    <div class="solution-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : index == indexActive}"
          v-for="(item, index) in AnchorsItems" :key="index" @click="goAnchor('#anchor-'+index, index)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="solution-bar-place" v-if="secondNavFixed"></div>
    <div id="anchor-0" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[0]}}
      </div>
      <div class="solution-content-intro-insurance">
          <div class="content">
            利用文字识别、自然语言处理等新兴人工智能技术，自动识别核保、理赔单据中的文字内容，并实现对关键字段的结构化提取，减轻保险公司核保、理赔处理人员的工作负担，节省人力成本。
          </div>
      </div>
    </div>
    <div id="anchor-1" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[1]}}
      </div>
      <div class="core-competence">
        <div class="core-competence-item"
          :class="{'core-even': (index % 2 == 0), 'last-core' : (index == (coreCompetence.length - 1))}"
          :style="{backgroundImage:'url(' + item.imgUrl + ')'}"
          v-for="(item, index) in coreCompetence"
          :key="index">
          <div class="core-img" ></div>
          <div class="core-title">
            {{item.title}}
          </div>
          <div class="core-content">
            {{item.content}}
          </div>
        </div>
      </div>
    </div>
    <div id="anchor-2" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[2]}}
      </div>
      <div class="advantage-container">
        <scheme-advantage :advantageInfo="advantageConstant.SolutionInsurance"></scheme-advantage>
      </div>
    </div>
    <div id="anchor-3" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[3]}}
      </div>
      <div class="application-container">
        <application-scene :sceneInfo="applicationConstant.SolutionInsurance"></application-scene>
      </div>
    </div>
    <div id="anchor-4" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[4]}}
      </div>
      <div class="client-case-insurance">
        <div class="icon-logo"
          v-for="(item, index) in clientCase"
          :key="index"
          :class="{'special-position' : item.pos}"
          :style="{backgroundImage: 'url(' + item.imgUrl + ')'}">
          <div class="info-container">
            <div class="instance-title">{{item.title}}</div>
            <div class="instance-info">{{item.content}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import SchemeAdvantage from '../common/SchemeAdvantage';
import ApplicationScene from '../common/ApplicationScene';
import bannerConstant from './data/BannerConstant';
import advantageConstant from './data/AdvantageConstant';
import applicationConstant from './data/ApplicationConstant';
import ScrollManager from '@/components/open/common/ScrollManager';
import HandleAnchor from './js/HandleAnchor';

const coreCompetence = [
  {
    title: '图像预处理',
    content: '运用图像算法，对图像实现版式分类、图像纠偏、质量过滤、红章去除等预处理。',
    imgUrl: require('./img/Insurance/znbx_pic1.1.jpg')
  },
  // {
  //   title: '高精度识别引擎',
  //   content: '针对保险场景，提供专用的高精度识别模型，满足客户的预期需求。',
  //   imgUrl: require('./img/Insurance/znbx_pic1.2.jpg')
  // },
  {
    title: '智能信息抽取',
    content: '优图智能结构化引擎利用图像算法结合自然语言处理技术，实现图像中表格及非表格区域文本的结构化输出。',
    imgUrl: require('./img/Insurance/znbx_pic1.3.jpg')
  }
];
const clientCase = [
  {
    title: '泰康核保',
    imgUrl: require('./img/case/caselogo_taikang.png'),
    content: '智能核保系统，由腾讯优图和腾讯云团队联合打造，旨在识别和提取出体检单据中的健康数据，并进行核保预测。在使用智能核保识别之前，客户体检报告的录入一直高度依赖于人工，应用核保识别之后，信息录入的效率大幅度提升，降低了成本和风险。'
  }
];

export default {
  name: '',
  components: {
    SolutionBanner,
    SchemeAdvantage,
    ApplicationScene
  },
  data() {
    return {
      bannerConstant,
      advantageConstant,
      applicationConstant,
      clientCase,
      coreCompetence,
      AnchorsItems: ['方案介绍', '核心能力', '方案优势', '应用场景', '客户案例'],
      secondNavFixed: false,
      indexActive: 0
    };
  },
  methods: {
    handleMouseScroll(param) {
      HandleAnchor.mouseScroll(param, this);
    },
    goAnchor(selector, index) {
      HandleAnchor.mouseClick(selector, index, this);
    }
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.solution-security {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner {
    height: 482px;
  }
  .solution-bar-place{
    height: 60px;
    width: 100%
  }
  .solution-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 2;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
        &.active-anchors{
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .items-details{
    padding-bottom: 70px;
    overflow: hidden;
  }
  .core-competence{
    width: 1170px;
    margin: 0 auto;
    overflow: hidden;
    font-size: 0;
    .core-competence-item{
      vertical-align: top;
      width: 570px;
      height: 510px;
      margin-bottom: 30px;
      padding: 336px 20px 0 20px;
      display: inline-block;
      background-repeat: no-repeat;
      border: #e6e6e6 1px solid;
      color: #242526;
      &.core-even{
        margin-right: 30px;
      }
      &.last-core{
        margin-bottom: 0;
      }
      .core-title{
        font-size: 24px;
        line-height: 1.0;
        text-align: center;
      }
      .core-content{
        line-height: 1.8;
        font-size: 16px;
        text-align: justify;
        margin-top: 36px;
      }
    }
  }
  .solution-title{
    margin-top: 70px;
    margin-bottom: 40px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 1.0;
  }
  .solution-content-intro-insurance{
    width: 1170px;
    margin: 0 auto;
    color: #212121;
    .content{
      font-size: 16px;
      line-height: 1.8;
      text-align: justify;
    }
    .img-title {
      margin-top: 58px;
      margin-bottom: 26px;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.0;
    }
  }
  .client-case-insurance{
    width: 1194px;
    margin: 0 auto;
    .icon-logo{
      border: 1px solid rgba(21,21,21,0.05);
      box-shadow: 0 10px 20px rgba(0,0,0,0.05), 0 6px 6px rgba(0,0,0,0.03);
      min-height: 160px;
      height: 100%;
      margin-bottom: 26px;
      background-repeat: no-repeat;
      background-position: 68px center;
      &.special-position{
        background-position: 40px center;
      }
    }
    .info-container{
      min-height: 160px;
      margin-left: 300px;
      background-image: url(./img/case/instance_background.png);
      background-repeat: no-repeat;
      background-position: 0 center;
      padding: 32px 42px 0;
      .instance-title{
        padding-bottom: 20px;
        font-size: 22px;
        color: #242526;
        text-align: left;
      }
      .instance-info{
        font-size: 16px;
        color: #212121;
        line-height: 1.8;
        text-align: justify;
        padding-bottom: 40px;
        &.has-two-para{
          padding-bottom: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionInsurance.vue